import { init } from "./main";
init();
